__turbopack_context__.v({
  "content": "HeroBanner-module-scss-module__aLrt1q__content",
  "model": "HeroBanner-module-scss-module__aLrt1q__model",
  "root": "HeroBanner-module-scss-module__aLrt1q__root",
  "subtitle": "HeroBanner-module-scss-module__aLrt1q__subtitle",
  "title": "HeroBanner-module-scss-module__aLrt1q__title",
});
